export const generateDocumentTypes = [
    "Criminal", "Civil", "Constitutional", "Family", "Corporate", "Property",
    "Contract", "Bonds", "Agreement", "Power of Attorney", "Affidavit", "Deed",
    "Will", "Trademark & Copyright (IPR)", "Trust", "Lease", "Employment Contract",
    "NDA", "MOU (Memorandum of Understanding)", "Income Tax Notice", "GST Notice",
    "Tax Assessment Order", "Shareholders Agreement", "Board Resolution",
    "Service Agreement", "Vendor Agreement", "Partnership Deed", "Loan Agreement",
    "Franchise Agreement", "Licensing Agreement", "Share Transfer Deed",
    "Special Leave Petition", "Writ Petition", "Criminal Appeal", "Civil Appeal",
    "Bail Application", "Review Petition", "Curative Petition", "Revision Petition",
    "Application under Section 482 CrPC",
    "Terms & Conditions", "Privacy Policy", "Refund Policy",
    "Other",
];

export type GenerateCustomFieldType = "string" | "number" | "boolean" | "date";

export interface GenerateCustomField {
    name: string;
    value: any;
    type: GenerateCustomFieldType;
}

// Document type to required fields mapping
export const generateDocumentTypeFields: Record<string, GenerateCustomField[]> = {
    Contract: [
        { name: "Party A Name", value: "", type: "string" },
        { name: "Party B Name", value: "", type: "string" },
        { name: "Contract Date", value: "", type: "date" },
        { name: "Effective Date", value: "", type: "date" },
        { name: "Termination Date", value: "", type: "date" },
        { name: "Consideration Amount", value: "", type: "number" },
        { name: "Payment Terms", value: "", type: "string" },
        { name: "Jurisdiction", value: "", type: "string" },
    ],
    Agreement: [
        { name: "Party A Name", value: "", type: "string" },
        { name: "Party B Name", value: "", type: "string" },
        { name: "Agreement Date", value: "", type: "date" },
        { name: "Effective Date", value: "", type: "date" },
        { name: "Agreement Terms", value: "", type: "string" },
        { name: "Consideration", value: "", type: "string" },
    ],
    "Legal Notice": [
        { name: "Notice From", value: "", type: "string" },
        { name: "Notice To", value: "", type: "string" },
        { name: "Notice Date", value: "", type: "date" },
        { name: "Subject Matter", value: "", type: "string" },
        { name: "Compliance Deadline", value: "", type: "date" },
        { name: "Legal Basis", value: "", type: "string" },
    ],
    "Power of Attorney": [
        { name: "Principal Name", value: "", type: "string" },
        { name: "Principal Address", value: "", type: "string" },
        { name: "Agent Name", value: "", type: "string" },
        { name: "Agent Address", value: "", type: "string" },
        { name: "POA Date", value: "", type: "date" },
        { name: "Authority Granted", value: "", type: "string" },
        { name: "Expiration Date", value: "", type: "date" },
        { name: "Notarization Required", value: "true", type: "boolean" },
        { name: "Witness Required", value: "true", type: "boolean" },
    ],
    Affidavit: [
        { name: "Deponent Name", value: "", type: "string" },
        { name: "Deponent Address", value: "", type: "string" },
        { name: "Affidavit Date", value: "", type: "date" },
        { name: "Sworn Before", value: "", type: "string" },
        { name: "Notary Public Name", value: "", type: "string" },
        { name: "Notary Commission Expiry", value: "", type: "date" },
        { name: "Statement of Facts", value: "", type: "string" },
    ],
    Deed: [
        { name: "Grantor Name", value: "", type: "string" },
        { name: "Grantor Address", value: "", type: "string" },
        { name: "Grantee Name", value: "", type: "string" },
        { name: "Grantee Address", value: "", type: "string" },
        { name: "Property Description", value: "", type: "string" },
        { name: "Property Address", value: "", type: "string" },
        { name: "Deed Date", value: "", type: "date" },
        { name: "Consideration Amount", value: "", type: "number" },
        { name: "Execution Date", value: "", type: "date" },
    ],
    Will: [
        { name: "Testator Name", value: "", type: "string" },
        { name: "Testator Address", value: "", type: "string" },
        { name: "Will Date", value: "", type: "date" },
        { name: "Executor Name", value: "", type: "string" },
        { name: "Executor Address", value: "", type: "string" },
        { name: "Beneficiary Names", value: "", type: "string" },
        { name: "Asset Description", value: "", type: "string" },
        { name: "Witness 1 Name", value: "", type: "string" },
        { name: "Witness 2 Name", value: "", type: "string" },
    ],
    Trust: [
        { name: "Settlor Name", value: "", type: "string" },
        { name: "Settlor Address", value: "", type: "string" },
        { name: "Trustee Name", value: "", type: "string" },
        { name: "Trustee Address", value: "", type: "string" },
        { name: "Beneficiary Names", value: "", type: "string" },
        { name: "Trust Date", value: "", type: "date" },
        { name: "Trust Property", value: "", type: "string" },
        { name: "Trust Purpose", value: "", type: "string" },
    ],
    Lease: [
        { name: "Landlord Name", value: "", type: "string" },
        { name: "Landlord Address", value: "", type: "string" },
        { name: "Tenant Name", value: "", type: "string" },
        { name: "Tenant Address", value: "", type: "string" },
        { name: "Property Address", value: "", type: "string" },
        { name: "Lease Start Date", value: "", type: "date" },
        { name: "Lease End Date", value: "", type: "date" },
        { name: "Monthly Rent", value: "", type: "number" },
        { name: "Security Deposit", value: "", type: "number" },
        { name: "Lease Term (Months)", value: "", type: "number" },
    ],
    "Employment Contract": [
        { name: "Employee Name", value: "", type: "string" },
        { name: "Employee Address", value: "", type: "string" },
        { name: "Employer Name", value: "", type: "string" },
        { name: "Employer Address", value: "", type: "string" },
        { name: "Position Title", value: "", type: "string" },
        { name: "Start Date", value: "", type: "date" },
        { name: "Salary Amount", value: "", type: "number" },
        { name: "Salary Frequency", value: "", type: "string" },
        { name: "Job Description", value: "", type: "string" },
        { name: "Termination Notice Period", value: "", type: "string" },
    ],
    NDA: [
        { name: "Disclosing Party Name", value: "", type: "string" },
        { name: "Disclosing Party Address", value: "", type: "string" },
        { name: "Receiving Party Name", value: "", type: "string" },
        { name: "Receiving Party Address", value: "", type: "string" },
        { name: "NDA Date", value: "", type: "date" },
        { name: "Confidential Information Description", value: "", type: "string" },
        { name: "Duration (Years)", value: "", type: "number" },
        { name: "Exceptions", value: "", type: "string" },
    ],
    Criminal: [
        { name: "Case Number", value: "", type: "string" },
        { name: "Court Name", value: "", type: "string" },
        { name: "Plaintiff Name", value: "", type: "string" },
        { name: "Defendant Name", value: "", type: "string" },
        { name: "Charges", value: "", type: "string" },
        { name: "Date of Incident", value: "", type: "date" },
        { name: "Date Filed", value: "", type: "date" },
        { name: "Jurisdiction", value: "", type: "string" },
    ],
    Civil: [
        { name: "Case Number", value: "", type: "string" },
        { name: "Court Name", value: "", type: "string" },
        { name: "Plaintiff Name", value: "", type: "string" },
        { name: "Defendant Name", value: "", type: "string" },
        { name: "Cause of Action", value: "", type: "string" },
        { name: "Date Filed", value: "", type: "date" },
        { name: "Amount in Controversy", value: "", type: "number" },
        { name: "Jurisdiction", value: "", type: "string" },
    ],
    Constitutional: [
        { name: "Case Number", value: "", type: "string" },
        { name: "Court Name", value: "", type: "string" },
        { name: "Petitioner Name", value: "", type: "string" },
        { name: "Respondent Name", value: "", type: "string" },
        { name: "Constitutional Issue", value: "", type: "string" },
        { name: "Date Filed", value: "", type: "date" },
        { name: "Relevant Constitutional Provision", value: "", type: "string" },
    ],
    Family: [
        { name: "Case Number", value: "", type: "string" },
        { name: "Court Name", value: "", type: "string" },
        { name: "Petitioner Name", value: "", type: "string" },
        { name: "Respondent Name", value: "", type: "string" },
        { name: "Case Type", value: "", type: "string" },
        { name: "Date Filed", value: "", type: "date" },
        { name: "Marriage Date", value: "", type: "date" },
        { name: "Children Names", value: "", type: "string" },
    ],
    Corporate: [
        { name: "Company Name", value: "", type: "string" },
        { name: "Company Registration Number", value: "", type: "string" },
        { name: "Company Address", value: "", type: "string" },
        { name: "Directors Names", value: "", type: "string" },
        { name: "Share Capital", value: "", type: "number" },
        { name: "Incorporation Date", value: "", type: "date" },
        { name: "Business Activity", value: "", type: "string" },
    ],
    Property: [
        { name: "Property Owner Name", value: "", type: "string" },
        { name: "Property Address", value: "", type: "string" },
        { name: "Property Description", value: "", type: "string" },
        { name: "Property Type", value: "", type: "string" },
        { name: "Property Value", value: "", type: "number" },
        { name: "Registration Date", value: "", type: "date" },
        { name: "Survey Number", value: "", type: "string" },
    ],
    Bonds: [
        { name: "Bond Issuer Name", value: "", type: "string" },
        { name: "Bond Holder Name", value: "", type: "string" },
        { name: "Bond Amount", value: "", type: "number" },
        { name: "Bond Date", value: "", type: "date" },
        { name: "Maturity Date", value: "", type: "date" },
        { name: "Interest Rate", value: "", type: "number" },
        { name: "Bond Type", value: "", type: "string" },
    ],
    "Trademark & Copyright (IPR)": [
        { name: "Owner Name", value: "", type: "string" },
        { name: "Owner Address", value: "", type: "string" },
        { name: "Trademark/Copyright Name", value: "", type: "string" },
        { name: "Registration Number", value: "", type: "string" },
        { name: "Registration Date", value: "", type: "date" },
        { name: "Expiry Date", value: "", type: "date" },
        { name: "Class/Category", value: "", type: "string" },
        { name: "Description", value: "", type: "string" },
    ],
    "MOU (Memorandum of Understanding)": [
        { name: "Party A Name", value: "", type: "string" },
        { name: "Party A Address", value: "", type: "string" },
        { name: "Party B Name", value: "", type: "string" },
        { name: "Party B Address", value: "", type: "string" },
        { name: "MOU Date", value: "", type: "date" },
        { name: "Effective Date", value: "", type: "date" },
        { name: "Purpose", value: "", type: "string" },
        { name: "Terms and Conditions", value: "", type: "string" },
    ],
    "Income Tax Notice": [
        { name: "Document Identification Number (DIN)", value: "", type: "string" },
        { name: "Notice Date", value: "", type: "date" },
        { name: "Assessment Year", value: "", type: "string" },
        { name: "PAN Number", value: "", type: "string" },
        { name: "Taxpayer Name", value: "", type: "string" },
        { name: "Taxpayer Address", value: "", type: "string" },
        { name: "Section of Income Tax Act", value: "", type: "string" },
        { name: "Reason for Notice", value: "", type: "string" },
        { name: "Income Declared", value: "", type: "number" },
        { name: "Income Assessed", value: "", type: "number" },
        { name: "Tax Liability", value: "", type: "number" },
        { name: "Response Deadline", value: "", type: "date" },
        { name: "Assessing Officer Name", value: "", type: "string" },
        { name: "Assessing Officer Jurisdiction", value: "", type: "string" },
        { name: "Documents Required", value: "", type: "string" },
    ],
    "GST Notice": [
        { name: "Notice Form Number", value: "", type: "string" },
        { name: "Notice Date", value: "", type: "date" },
        { name: "GSTIN", value: "", type: "string" },
        { name: "Taxpayer Name", value: "", type: "string" },
        { name: "Taxpayer Address", value: "", type: "string" },
        { name: "Notice Type", value: "", type: "string" },
        { name: "Tax Period", value: "", type: "string" },
        { name: "Reason for Notice", value: "", type: "string" },
        { name: "Discrepancy Details", value: "", type: "string" },
        { name: "Tax Amount Involved", value: "", type: "number" },
        { name: "Interest Amount", value: "", type: "number" },
        { name: "Penalty Amount", value: "", type: "number" },
        { name: "Total Amount Payable", value: "", type: "number" },
        { name: "Response Deadline", value: "", type: "date" },
        { name: "Issuing Authority Name", value: "", type: "string" },
        { name: "Issuing Authority Jurisdiction", value: "", type: "string" },
        { name: "Action Required", value: "", type: "string" },
    ],
    "Tax Assessment Order": [
        { name: "Assessment Order Number", value: "", type: "string" },
        { name: "Order Date", value: "", type: "date" },
        { name: "Assessment Year", value: "", type: "string" },
        { name: "PAN Number", value: "", type: "string" },
        { name: "Assessee Name", value: "", type: "string" },
        { name: "Assessee Address", value: "", type: "string" },
        { name: "Type of Assessment", value: "", type: "string" },
        { name: "Income Declared", value: "", type: "number" },
        { name: "Income Assessed", value: "", type: "number" },
        { name: "Total Deductions Claimed", value: "", type: "number" },
        { name: "Total Deductions Allowed", value: "", type: "number" },
        { name: "Taxable Income", value: "", type: "number" },
        { name: "Tax Liability", value: "", type: "number" },
        { name: "Tax Already Paid", value: "", type: "number" },
        { name: "Interest Charged", value: "", type: "number" },
        { name: "Penalty Imposed", value: "", type: "number" },
        { name: "Refund Due", value: "", type: "number" },
        { name: "Balance Payable", value: "", type: "number" },
        { name: "Assessing Officer Name", value: "", type: "string" },
        { name: "Assessing Officer Designation", value: "", type: "string" },
        { name: "Payment Deadline", value: "", type: "date" },
        { name: "Appeal Rights", value: "", type: "string" },
    ],
    "Shareholders Agreement": [
        { name: "Company Name", value: "", type: "string" },
        { name: "Company Registration Number", value: "", type: "string" },
        { name: "Agreement Date", value: "", type: "date" },
        { name: "Shareholder 1 Name", value: "", type: "string" },
        { name: "Shareholder 1 Shareholding %", value: "", type: "number" },
        { name: "Shareholder 2 Name", value: "", type: "string" },
        { name: "Shareholder 2 Shareholding %", value: "", type: "number" },
        { name: "Total Share Capital", value: "", type: "number" },
        { name: "Board Composition", value: "", type: "string" },
        { name: "Dividend Policy", value: "", type: "string" },
        { name: "Transfer Restrictions", value: "", type: "string" },
        { name: "Pre-emption Rights", value: "", type: "string" },
        { name: "Drag-Along Rights", value: "", type: "string" },
        { name: "Tag-Along Rights", value: "", type: "string" },
        { name: "Reserved Matters", value: "", type: "string" },
        { name: "Dispute Resolution Mechanism", value: "", type: "string" },
    ],
    "Board Resolution": [
        { name: "Company Name", value: "", type: "string" },
        { name: "Company Registration Number", value: "", type: "string" },
        { name: "Resolution Date", value: "", type: "date" },
        { name: "Meeting Type", value: "", type: "string" },
        { name: "Resolution Number", value: "", type: "string" },
        { name: "Resolution Type", value: "", type: "string" },
        { name: "Subject Matter", value: "", type: "string" },
        { name: "Proposed By", value: "", type: "string" },
        { name: "Seconded By", value: "", type: "string" },
        { name: "Votes For", value: "", type: "number" },
        { name: "Votes Against", value: "", type: "number" },
        { name: "Abstentions", value: "", type: "number" },
        { name: "Chairperson Name", value: "", type: "string" },
        { name: "Secretary Name", value: "", type: "string" },
    ],
    "Service Agreement": [
        { name: "Service Provider Name", value: "", type: "string" },
        { name: "Service Provider Address", value: "", type: "string" },
        { name: "Client Name", value: "", type: "string" },
        { name: "Client Address", value: "", type: "string" },
        { name: "Agreement Date", value: "", type: "date" },
        { name: "Service Start Date", value: "", type: "date" },
        { name: "Service End Date", value: "", type: "date" },
        { name: "Scope of Services", value: "", type: "string" },
        { name: "Deliverables", value: "", type: "string" },
        { name: "Service Fee", value: "", type: "number" },
        { name: "Payment Terms", value: "", type: "string" },
        { name: "Intellectual Property Ownership", value: "", type: "string" },
        { name: "Confidentiality Terms", value: "", type: "string" },
        { name: "Termination Notice Period", value: "", type: "string" },
    ],
    "Vendor Agreement": [
        { name: "Vendor Name", value: "", type: "string" },
        { name: "Vendor Address", value: "", type: "string" },
        { name: "Buyer Name", value: "", type: "string" },
        { name: "Buyer Address", value: "", type: "string" },
        { name: "Agreement Date", value: "", type: "date" },
        { name: "Goods/Services Description", value: "", type: "string" },
        { name: "Quantity", value: "", type: "string" },
        { name: "Unit Price", value: "", type: "number" },
        { name: "Total Contract Value", value: "", type: "number" },
        { name: "Quality Standards", value: "", type: "string" },
        { name: "Delivery Schedule", value: "", type: "string" },
        { name: "Payment Terms", value: "", type: "string" },
        { name: "Warranty Period", value: "", type: "string" },
        { name: "Penalties for Delay", value: "", type: "string" },
    ],
    "Partnership Deed": [
        { name: "Partnership Firm Name", value: "", type: "string" },
        { name: "Partnership Date", value: "", type: "date" },
        { name: "Partner 1 Name", value: "", type: "string" },
        { name: "Partner 1 Address", value: "", type: "string" },
        { name: "Partner 1 Capital Contribution", value: "", type: "number" },
        { name: "Partner 2 Name", value: "", type: "string" },
        { name: "Partner 2 Address", value: "", type: "string" },
        { name: "Partner 2 Capital Contribution", value: "", type: "number" },
        { name: "Business Nature", value: "", type: "string" },
        { name: "Profit Sharing Ratio", value: "", type: "string" },
        { name: "Loss Sharing Ratio", value: "", type: "string" },
        { name: "Salary/Remuneration", value: "", type: "string" },
        { name: "Interest on Capital", value: "", type: "number" },
        { name: "Drawings Limit", value: "", type: "number" },
        { name: "Admission of New Partner Terms", value: "", type: "string" },
        { name: "Retirement/Death Provisions", value: "", type: "string" },
    ],
    "Loan Agreement": [
        { name: "Lender Name", value: "", type: "string" },
        { name: "Lender Address", value: "", type: "string" },
        { name: "Borrower Name", value: "", type: "string" },
        { name: "Borrower Address", value: "", type: "string" },
        { name: "Loan Agreement Date", value: "", type: "date" },
        { name: "Loan Amount", value: "", type: "number" },
        { name: "Interest Rate (%)", value: "", type: "number" },
        { name: "Loan Tenure (Months)", value: "", type: "number" },
        { name: "Repayment Schedule", value: "", type: "string" },
        { name: "EMI Amount", value: "", type: "number" },
        { name: "Loan Purpose", value: "", type: "string" },
        { name: "Security/Collateral", value: "", type: "string" },
        { name: "Prepayment Terms", value: "", type: "string" },
        { name: "Default Consequences", value: "", type: "string" },
        { name: "Guarantor Name", value: "", type: "string" },
    ],
    "Franchise Agreement": [
        { name: "Franchisor Name", value: "", type: "string" },
        { name: "Franchisor Address", value: "", type: "string" },
        { name: "Franchisee Name", value: "", type: "string" },
        { name: "Franchisee Address", value: "", type: "string" },
        { name: "Agreement Date", value: "", type: "date" },
        { name: "Franchise Territory", value: "", type: "string" },
        { name: "Franchise Term (Years)", value: "", type: "number" },
        { name: "Initial Franchise Fee", value: "", type: "number" },
        { name: "Ongoing Royalty (%)", value: "", type: "number" },
        { name: "Marketing Fee (%)", value: "", type: "number" },
        { name: "Brand Usage Rights", value: "", type: "string" },
        { name: "Training and Support", value: "", type: "string" },
        { name: "Quality Standards", value: "", type: "string" },
        { name: "Renewal Terms", value: "", type: "string" },
        { name: "Termination Conditions", value: "", type: "string" },
    ],
    "Licensing Agreement": [
        { name: "Licensor Name", value: "", type: "string" },
        { name: "Licensor Address", value: "", type: "string" },
        { name: "Licensee Name", value: "", type: "string" },
        { name: "Licensee Address", value: "", type: "string" },
        { name: "Agreement Date", value: "", type: "date" },
        { name: "Licensed Property/IP", value: "", type: "string" },
        { name: "License Type", value: "", type: "string" },
        { name: "Territory", value: "", type: "string" },
        { name: "License Duration", value: "", type: "string" },
        { name: "Royalty Rate (%)", value: "", type: "number" },
        { name: "Minimum Royalty", value: "", type: "number" },
        { name: "Exclusivity Terms", value: "", type: "string" },
        { name: "Quality Control Standards", value: "", type: "string" },
        { name: "Sublicensing Rights", value: "", type: "string" },
        { name: "Termination Rights", value: "", type: "string" },
    ],
    "Share Transfer Deed": [
        { name: "Company Name", value: "", type: "string" },
        { name: "Company Registration Number", value: "", type: "string" },
        { name: "Transfer Date", value: "", type: "date" },
        { name: "Transferor Name", value: "", type: "string" },
        { name: "Transferor Address", value: "", type: "string" },
        { name: "Transferee Name", value: "", type: "string" },
        { name: "Transferee Address", value: "", type: "string" },
        { name: "Number of Shares", value: "", type: "number" },
        { name: "Share Certificate Number", value: "", type: "string" },
        { name: "Distinctive Numbers", value: "", type: "string" },
        { name: "Face Value per Share", value: "", type: "number" },
        { name: "Transfer Consideration", value: "", type: "number" },
        { name: "Stamp Duty Paid", value: "", type: "number" },
        { name: "Board Approval Date", value: "", type: "date" },
    ],
    "Special Leave Petition": [
        { name: "Petitioner Name", value: "", type: "string" },
        { name: "Respondent Name", value: "", type: "string" },
        { name: "Lower Court Name", value: "", type: "string" },
        { name: "Impugned Order Number", value: "", type: "string" },
        { name: "Date of Impugned Order", value: "", type: "date" },
        { name: "Ground for SLP", value: "", type: "string" },
        { name: "Limitation Period (Days)", value: "", type: "number" },
    ],
    "Writ Petition": [
        { name: "Petitioner Name", value: "", type: "string" },
        { name: "Respondent Name", value: "", type: "string" },
        { name: "Court Name", value: "", type: "string" },
        { name: "Writ Type", value: "", type: "string" },
        { name: "Constitutional Articles Violated", value: "", type: "string" },
        { name: "Relief Sought", value: "", type: "string" },
    ],
    "Criminal Appeal": [
        { name: "Appellant Name", value: "", type: "string" },
        { name: "Respondent Name", value: "", type: "string" },
        { name: "Case Number (Trial Court)", value: "", type: "string" },
        { name: "Trial Court Name", value: "", type: "string" },
        { name: "Section(s) Involved", value: "", type: "string" },
        { name: "Date of Conviction/Order", value: "", type: "date" },
        { name: "Sentence Awarded", value: "", type: "string" },
    ],
    "Civil Appeal": [
        { name: "Appellant Name", value: "", type: "string" },
        { name: "Respondent Name", value: "", type: "string" },
        { name: "Original Suit Number", value: "", type: "string" },
        { name: "Lower Court Name", value: "", type: "string" },
        { name: "Date of Decree/Judgment", value: "", type: "date" },
        { name: "Valuable Claim Amount", value: "", type: "number" },
    ],
    "Bail Application": [
        { name: "Applicant Name", value: "", type: "string" },
        { name: "FIR Number", value: "", type: "string" },
        { name: "Police Station", value: "", type: "string" },
        { name: "Charges (Sections)", value: "", type: "string" },
        { name: "Grounds for Bail", value: "", type: "string" },
    ],
    "Review Petition": [
        { name: "Petitioner Name", value: "", type: "string" },
        { name: "Respondent Name", value: "", type: "string" },
        { name: "Case Number to be Reviewed", value: "", type: "string" },
        { name: "Date of Judgment", value: "", type: "date" },
        { name: "Error Apparent on Record", value: "", type: "string" },
    ],
    "Curative Petition": [
        { name: "Petitioner Name", value: "", type: "string" },
        { name: "Respondent Name", value: "", type: "string" },
        { name: "Review Petition Number", value: "", type: "string" },
        { name: "Dismissal Date of Review Petition", value: "", type: "date" },
        { name: "Grounds for Curative Petition", value: "", type: "string" },
    ],
    "Revision Petition": [
        { name: "Petitioner Name", value: "", type: "string" },
        { name: "Respondent Name", value: "", type: "string" },
        { name: "Case Number", value: "", type: "string" },
        { name: "Lower Court Name", value: "", type: "string" },
        { name: "Impugned Order Date", value: "", type: "date" },
        { name: "Jurisdictional Error Grounds", value: "", type: "string" },
    ],
    "Application under Section 482 CrPC": [
        { name: "Applicant Name", value: "", type: "string" },
        { name: "Respondent Name", value: "", type: "string" },
        { name: "FIR Number / Case Number", value: "", type: "string" },
        { name: "Police Station / Court", value: "", type: "string" },
        { name: "Specific Relief", value: "", type: "string" },
        { name: "Grounds for Inherent Power", value: "", type: "string" },
    ],
    "Terms & Conditions": [
        { name: "Company/Entity Name", value: "", type: "string" },
        { name: "Website/Application Name", value: "", type: "string" },
        { name: "Effective Date", value: "", type: "date" },
        { name: "Jurisdiction/Governing Law", value: "", type: "string" },
        { name: "User Age Eligibility", value: "", type: "string" },
        { name: "User Obligations/Prohibited Activities", value: "", type: "string" },
        { name: "Intellectual Property Ownership Details", value: "", type: "string" },
        { name: "Limitation of Liability Terms", value: "", type: "string" },
        { name: "Account Termination Grounds", value: "", type: "string" },
        { name: "Payment/Subscription Terms", value: "", type: "string" },
        { name: "Dispute Resolution Method (Arbitration/Court)", value: "", type: "string" },
        { name: "Contact Email", value: "", type: "string" },
    ],
    "Privacy Policy": [
        { name: "Company/Entity Name", value: "", type: "string" },
        { name: "Website/Application Name", value: "", type: "string" },
        { name: "Effective Date", value: "", type: "date" },
        { name: "Types of Personal Data Collected", value: "", type: "string" },
        { name: "Purpose of Data Collection", value: "", type: "string" },
        { name: "Data Retention Period", value: "", type: "string" },
        { name: "Third-Party Data Sharing/Partners", value: "", type: "string" },
        { name: "Security Measures for Data Protection", value: "", type: "string" },
        { name: "User Rights (Access, Correction, Deletion)", value: "", type: "string" },
        { name: "Cookies/Tracking Technologies Used", value: "", type: "string" },
        { name: "Children's Privacy Compliance", value: "", type: "string" },
        { name: "Data Controller/DPO Name", value: "", type: "string" },
        { name: "Contact Email for Data Requests", value: "", type: "string" },
    ],
    "Refund Policy": [
        { name: "Company/Entity Name", value: "", type: "string" },
        { name: "Website/Application Name", value: "", type: "string" },
        { name: "Effective Date", value: "", type: "date" },
        { name: "Refund Eligibility Criteria", value: "", type: "string" },
        { name: "Non-Refundable Items/Services", value: "", type: "string" },
        { name: "Refund Period (Days)", value: "", type: "number" },
        { name: "Process to Request a Refund", value: "", type: "string" },
        { name: "Timeframe for Refund Processing", value: "", type: "string" },
        { name: "Return Shipping Responsibility", value: "", type: "string" },
        { name: "Exchange/Replacement Policy", value: "", type: "string" },
        { name: "Contact Email for Refunds", value: "", type: "string" },
    ],
    "Other": [
        { name: "Document Title", value: "", type: "string" },
        { name: "Document Date", value: "", type: "date" },
        { name: "Description/Context", value: "", type: "string" },
    ],
};
